  import React, { Fragment, useEffect, useState } from "react";
  import { Helmet } from "react-helmet";
  import { PageBanner } from "../../components";
import PaymentMethod from "../../components/PaymentMethod/PaymentMethod";
  
  function PaymentIntegration() {
  
    return (
      <Fragment>
        <Helmet>
          <title>Payment-Integration - d2p</title>
        </Helmet>
        <PageBanner title="Payment Integration" image="/assets/images/bg4.jpg" />
        <PaymentMethod redirect={true}/>
      </Fragment>
    );
  }
  
  export default PaymentIntegration;
  